module.exports = __webpack_public_path__ + "img/home-img-05.643062c7.png";